module.exports = __webpack_public_path__ + "static/media/mozambique-shipping-map.46da7bf1.jpg";